import ProductPriceMaintain from './product_price_maintain.vue';

export default ProductPriceMaintain;
